import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { SenderListInterface } from '../types/sender-list';
import {
  SenderListFilter,
  defaultSenderListFilter,
} from '../types/sender-list-filter';
import {
  AddSenderInterface,
  UpdateSenderInterface,
} from '../types/upsert-sender';
import {
  UpdateSenderActiveStatusInterface,
  UpdateSenderDeviceVerificationInterface,
  UpdateSenderKycAmlStatusInterface,
  UpdateSenderPasswordInterface,
  UpdateSenderPinInterface,
} from '../types/sender-action';

@Injectable({
  providedIn: 'root',
})
export class SenderService {
  constructor(private httpClient: HttpClientService) {}

  getSenderList(
    payload: SenderListFilter = defaultSenderListFilter
  ): Observable<ResponseIdentity<DataGrid<SenderListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.sender.getSenderList,
      removeEmptyStrings(payload)
    );
  }

  getSenderDropdown(
    partner_id?: number
  ): Observable<ResponseIdentity<SenderListInterface[]>> {
    return this.httpClient.post(
      API_URL_CONSTANT.sender.getSenderList,
      partner_id
        ? {
            partner_id: [partner_id],
          }
        : {}
    );
  }

  getSenderDetails(payload: {
    sender_id: number;
  }): Observable<ResponseIdentity<SenderListInterface>> {
    return this.httpClient.post(
      API_URL_CONSTANT.sender.getSenderDetails,
      payload
    );
  }

  addSender(payload: AddSenderInterface): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.sender.addSender, payload);
  }

  updateSender(
    payload: UpdateSenderInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.sender.updateSender, payload);
  }

  /**
   * Device verification is a partial update through the generic updateSender
   * endpoint - only the sender id and the flag are sent.
   */
  updateSenderDeviceVerification(
    payload: UpdateSenderDeviceVerificationInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.sender.updateSender, payload);
  }

  updateSenderActiveStatus(
    payload: UpdateSenderActiveStatusInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.sender.updateSenderActiveStatus,
      payload
    );
  }

  updateSenderKycAmlStatus(
    payload: UpdateSenderKycAmlStatusInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.sender.updateSenderKycAmlStatus,
      payload
    );
  }

  updateSenderPassword(
    payload: UpdateSenderPasswordInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.sender.updateSenderPassword,
      payload
    );
  }

  updateSenderPIN(
    payload: UpdateSenderPinInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.sender.updateSenderPIN,
      payload
    );
  }
}
